import { call, put, take } from 'redux-saga/effects';

import colorsJson from 'lib/modelBuilder/tests/fixtures/colors.json';

import ActionTypes from '../constants/colors';
import { requestGet } from 'utils/requests';
import { getColorsSuccess } from '../actions/colors';
import { loadColorsFromJson } from 'lib/modelBuilder/utils/dataStorage';
import { BASE_URL } from '../../App/constants';
import i18n from '../../../i18n';

export function* downloadColorsFromAPI() {
  if (false && process.env.NODE_ENV !== 'production') {
    const colors = yield call(loadColorsFromJson, JSON.stringify(colorsJson));
    yield put(getColorsSuccess(colors));
    return colors;
  } else {
    let languageCode = 'fr';
    if (i18n.language) {
      languageCode = i18n.language;
    }
    const url = `${BASE_URL}/${languageCode}/api/color/`;
    // const url = `${BASE_URL}/colors`;
    try {
      const response = yield call(requestGet, url);
      const colors = yield call(loadColorsFromJson, JSON.stringify(response));
      yield put(getColorsSuccess(colors));
      return colors;
    } catch (error) {
      // if (
      //   error &&
      //   error.statusText &&
      //   error.statusText.includes('Cannot connect.')
      // ) {
      //   // @ts-ignore
      //   const colors = yield call(
      //     loadColorsFromJson,
      //     JSON.stringify(colorsJson),
      //   );
      //   yield put(getColorsSuccess(colors));
      //   return colors;
      // }

      const colors = yield call(loadColorsFromJson, JSON.stringify(colorsJson));
      yield put(getColorsSuccess(colors));
      return colors;

      // yield put(getColorsFailure(error));
    }
  }
}

export default function* colorsSaga() {
  while (true) {
    yield take(ActionTypes.COLORS_REQUEST);
    yield call(downloadColorsFromAPI);
  }
}
